import Namespace from "./Namespace";
import IdResolver from "./IdResolver";
/**
 * The class to identity with XML namespace feature.
 */
export default class NSIdentity {
    constructor(qn, n) {
        if (typeof qn === "string") {
            qn = qn.split(".");
        }
        if (n) {
            this._ns = Namespace.defineByArray(qn);
            this._name = n;
        }
        else {
            this._name = qn[qn.length - 1];
            qn = qn.slice(0, qn.length - 1);
            this._ns = Namespace.defineByArray(qn);
        }
        this._fqn = this.ns.hierarchy.concat([this.name]).join(".");
        NSIdentity._instances[this._fqn] = this;
        NSIdentity._map.add(qn.concat([this._name]));
    }
    static get _map() {
        if (this._mapBackingField === void 0) {
            this._mapBackingField = new IdResolver();
        }
        return this._mapBackingField;
    }
    static fromFQN(fqn, name) {
        const hierarchy = NSIdentity._ensureQNTobeArray(fqn, name);
        fqn = hierarchy.join(".");
        const inst = NSIdentity._instances[fqn];
        if (inst) {
            return inst;
        }
        const splitted = fqn.split(".");
        return new NSIdentity(splitted);
    }
    static guess(...hierarchy) {
        return NSIdentity._from(hierarchy);
    }
    static clear() {
        NSIdentity._instances = {};
        NSIdentity._mapBackingField = new IdResolver();
    }
    /**
     * return instance if exists.
     * generate and return new instanse if not exist id has same fqn.
     * @param  {string[]}   hierarchy [description]
     * @return {NSIdentity}           [description]
     */
    static _from(hierarchy) {
        const fqn = hierarchy.join(".");
        const inst = NSIdentity._instances[fqn];
        if (inst) {
            return inst;
        }
        return NSIdentity.fromFQN(NSIdentity._map.resolve(Namespace.defineByArray(hierarchy)));
    }
    static _ensureQNTobeArray(arg1, name) {
        if (name) {
            return NSIdentity._ensureQNTobeArray(arg1.extend(name));
        }
        if (typeof arg1 === "string") {
            return arg1.split(".");
        }
        if (Array.isArray(arg1)) {
            return arg1;
        }
        return arg1.hierarchy;
    }
    /**
     * Namespace of this identity
     * @type {string}
     */
    get ns() {
        return this._ns;
    }
    /**
     * Short name for this identity
     * @type {string}
     */
    get name() {
        return this._name;
    }
    /**
     * Full qualified name of this identity
     * @type {string}
     */
    get fqn() {
        return this._fqn;
    }
    toString() {
        return this.fqn;
    }
}
NSIdentity._instances = {};



// WEBPACK FOOTER //
// ./src/Base/NSIdentity.ts